import React from 'react';
import { CTAButton } from './CTAButton';
export const ProductSection = () => {
  return <section className="w-full bg-gray-50 py-10 px-4" data-id="element-232">
      <div className="max-w-4xl mx-auto" data-id="element-233">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2 text-center" data-id="element-234">
          Cette Technologie Arrive Enfin au Québec
        </h2>
        <p className="text-gray-700 mb-8 text-center" data-id="element-235">
          Pendant 3 ans, j'ai supplié Dr. Weber de rendre cette technologie
          accessible au Canada. Le problème ? Les appareils coûtaient 15,000$ et
          n'étaient disponibles qu'en clinique.
        </p>
        <div className="bg-white p-6 rounded-lg shadow-md mb-8" data-id="element-236">
          <p className="text-gray-700 mb-6 text-center font-bold text-xl" data-id="element-237">
            Puis, en 2024, une percée :
          </p>
          <p className="text-gray-700 mb-8 text-center text-lg" data-id="element-238">
            Nevara Québec a réussi à miniaturiser cette technologie pour l'usage
            domestique.
          </p>
          <div className="bg-blue-600 text-white p-4 rounded-lg text-center mb-8" data-id="element-239">
            <h3 className="text-2xl font-bold mb-2" data-id="element-240">
              Présentation du KinéPulse
            </h3>
            <p className="text-lg" data-id="element-241">
              Le premier appareil 4-en-1 qui combine toutes ces thérapies dans
              un seul dispositif domestique.
            </p>
          </div>
          <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-242">
            <div className="md:w-1/2" data-id="element-243">
              <img src="https://images.unsplash.com/photo-1612708771321-1cfe5ce4cbf8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Appareil KinéPulse" className="w-full h-auto rounded-lg shadow-md mb-4" data-id="element-244" />
            </div>
            <div className="md:w-1/2" data-id="element-245">
              <ul className="space-y-4" data-id="element-246">
                <li className="flex items-start" data-id="element-247">
                  <div className="h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-248">
                    ✓
                  </div>
                  <p className="text-gray-700" data-id="element-249">
                    <span className="font-bold" data-id="element-250">EMS médical</span> - Stimulation
                    nerveuse profonde
                  </p>
                </li>
                <li className="flex items-start" data-id="element-251">
                  <div className="h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-252">
                    ✓
                  </div>
                  <p className="text-gray-700" data-id="element-253">
                    <span className="font-bold" data-id="element-254">Thermothérapie ciblée</span> -
                    Chaleur pénétrante
                  </p>
                </li>
                <li className="flex items-start" data-id="element-255">
                  <div className="h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-256">
                    ✓
                  </div>
                  <p className="text-gray-700" data-id="element-257">
                    <span className="font-bold" data-id="element-258">Massage thérapeutique</span> -
                    Drainage lymphatique
                  </p>
                </li>
                <li className="flex items-start" data-id="element-259">
                  <div className="h-6 w-6 rounded-full bg-blue-600 text-white flex items-center justify-center mr-3 mt-1 flex-shrink-0" data-id="element-260">
                    ✓
                  </div>
                  <p className="text-gray-700" data-id="element-261">
                    <span className="font-bold" data-id="element-262">Lumière rouge 660nm</span> -
                    Régénération cellulaire
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg mb-8" data-id="element-263">
            <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-264">
              Pourquoi KinéPulse est Différent :
            </h3>
            <div className="overflow-x-auto" data-id="element-265">
              <table className="w-full border-collapse" data-id="element-266">
                <thead data-id="element-267">
                  <tr data-id="element-268">
                    <th className="border border-gray-300 p-2 bg-gray-100" data-id="element-269"></th>
                    <th className="border border-gray-300 p-2 bg-gray-100" data-id="element-270">
                      Appareils TENS Classiques
                    </th>
                    <th className="border border-gray-300 p-2 bg-blue-100" data-id="element-271">
                      KinéPulse
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-272">
                  <tr data-id="element-273">
                    <td className="border border-gray-300 p-2 font-bold" data-id="element-274">
                      Nombre de thérapies
                    </td>
                    <td className="border border-gray-300 p-2" data-id="element-275">
                      1 seule (électricité)
                    </td>
                    <td className="border border-gray-300 p-2 bg-blue-50 font-bold" data-id="element-276">
                      4 simultanées
                    </td>
                  </tr>
                  <tr data-id="element-277">
                    <td className="border border-gray-300 p-2 font-bold" data-id="element-278">
                      Approche
                    </td>
                    <td className="border border-gray-300 p-2" data-id="element-279">
                      Masque la douleur
                    </td>
                    <td className="border border-gray-300 p-2 bg-blue-50 font-bold" data-id="element-280">
                      Traite les causes
                    </td>
                  </tr>
                  <tr data-id="element-281">
                    <td className="border border-gray-300 p-2 font-bold" data-id="element-282">
                      Intensité
                    </td>
                    <td className="border border-gray-300 p-2" data-id="element-283">
                      Faible (50mA max)
                    </td>
                    <td className="border border-gray-300 p-2 bg-blue-50 font-bold" data-id="element-284">
                      Médicale (150mA)
                    </td>
                  </tr>
                  <tr data-id="element-285">
                    <td className="border border-gray-300 p-2 font-bold" data-id="element-286">
                      Durabilité
                    </td>
                    <td className="border border-gray-300 p-2" data-id="element-287">6-12 mois</td>
                    <td className="border border-gray-300 p-2 bg-blue-50 font-bold" data-id="element-288">
                      Conçu pour durer
                    </td>
                  </tr>
                  <tr data-id="element-289">
                    <td className="border border-gray-300 p-2 font-bold" data-id="element-290">
                      Support
                    </td>
                    <td className="border border-gray-300 p-2" data-id="element-291">Aucun</td>
                    <td className="border border-gray-300 p-2 bg-blue-50 font-bold" data-id="element-292">
                      En français au Québec
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <CTAButton showPrice={true} data-id="element-293" />
        </div>
      </div>
    </section>;
};